import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="abortcontroller" id="abortcontroller"></a>
    <h1 {...{
      "id": "windowabortcontroller"
    }}>{`window.AbortController`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/AbortController"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/AbortController`}</a></p>
    <br></br> See also [AbortSignal](./AbortSignal.md#module:global.AbortSignal)  
    <a name="abortcontroller-signal" id="abortcontroller-signal"></a>
    <h2 {...{
      "id": "signal--abortsignal"
    }}>{`signal : `}<inlineCode parentName="h2">{`AbortSignal`}</inlineCode></h2>
    <p>{`AbortSignal object, which can be used to abort a request`}</p>
    <a name="abortcontroller-abort" id="abortcontroller-abort"></a>
    <h2 {...{
      "id": "abortreason"
    }}>{`abort(reason)`}</h2>
    <p>{`Aborts a request before it has completed.
If the reason is not specified, the reason is set to "AbortError" DomException`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the reason why the operation was aborted`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      